import React from 'react';
import Button from '@material-ui/core/Button';
import { connect, useDispatch } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { addAlert } from 'store/actions/alert/alerts';
import { authDelRequestWithParam, authPostRequest } from 'helpers/apiRequests';
import ButtonsUseStyles from 'consts/styles/Buttons';
import { formStyles } from 'consts/styles/Form';
import { editLocalZone } from 'store/actions/map/allZones';
import Icons from 'consts/icons';
import DisplayActivations from 'components/zones/ActivationsDisplay';
import AddPeriodicForm from '../../components/AddPeriodicForm/AddPeriodicForm';
import AddTemporaryActivationModal from '../../components/AddTemporaryActivationModal/AddTemporaryActivationModal';
import { checkDataRanges } from '../../../utils/zoneDetailsUtils';

const EditActivationForm = props => {
  const { language, zoneDetails } = props;
  const [days, setDays] = React.useState([]);
  const [hours, setHours] = React.useState([]);
  const [pickedHours, setPickedHours] = React.useState([]);
  const [weekdays, setWeekdays] = React.useState({});
  const [start, setStart] = React.useState(null);
  const [stop, setStop] = React.useState(null);
  const [activationType, setActivationType] = React.useState(false);
  const [canReset, setCanReset] = React.useState(0);
  const [addActivationFlag, setAddActivationFlag] = React.useState(false);

  const formClasses = formStyles();
  const classesButtons = ButtonsUseStyles();

  const dispatch = useDispatch();

  React.useEffect(() => {
    const localweekDays = {};
    Object.values(language.weekDays).forEach((eachDay, index) => {
      localweekDays[eachDay] = index + 1;
    });
    setWeekdays(localweekDays);
    setHours([...Array(24).keys()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (zoneDetails.activations.length) {
      setDays(
        zoneDetails.activations[0].days ? zoneDetails.activations[0].days : []
      );
      setPickedHours(
        zoneDetails.activations[0].hours ? zoneDetails.activations[0].hours : []
      );
      setActivationType(
        zoneDetails.activations[0].type ? zoneDetails.activations[0].type : ''
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneDetails]);

  const resetAll = () => {
    setStop(null);
    setStart(null);
    setDays([]);
    setPickedHours([]);
  };

  const toggleWeekdays = day => {
    const newDaysArr = [...days];
    if (newDaysArr.includes(weekdays[day])) {
      newDaysArr.splice(newDaysArr.indexOf(weekdays[day]), 1);
    } else {
      newDaysArr.push(weekdays[day]);
    }
    setDays(newDaysArr);
  };

  const toggleHours = hour => {
    const newHoursArr = [...pickedHours];
    if (pickedHours.includes(hour)) {
      newHoursArr.splice(newHoursArr.indexOf(hour), 1);
    } else {
      newHoursArr.push(hour);
    }
    setPickedHours(newHoursArr);
  };

  React.useEffect(() => {
    if (canReset) {
      resetAll();
    }
    if (activationType) {
      setCanReset(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activationType]);

  const handleChangeType = event => {
    setActivationType(event.target.value);
  };

  const handleDeletion = deletedActivationUid => {
    const zoneWithDeletedActivation = {
      ...zoneDetails,
      activations: zoneDetails.activations.filter(
        activationObject => activationObject.uid !== deletedActivationUid
      ),
    };
    dispatch(editLocalZone(zoneWithDeletedActivation));
  };

  const deleteActivationRequest = async activation => {
    const result = await authDelRequestWithParam('activations', activation.uid);
    if (result.status === 204) {
      dispatch(
        addAlert({
          title: language.alerts.addDataSuccess.title_,
          desc: language.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      handleDeletion(activation.uid);
    } else
      dispatch(
        addAlert({
          title: language.alerts[result.data.code].title_,
          desc: language.alerts[result.data.code].desc_,
          type: 'error',
        })
      );
  };

  const returnProperActivationList = addedActivationObject => {
    if (
      zoneDetails.activations[0]?.type === 'temporary' &&
      addedActivationObject.type === 'temporary'
    ) {
      return {
        ...zoneDetails,
        activations: [...zoneDetails.activations, addedActivationObject],
      };
    }
    return {
      ...zoneDetails,
      activations: [addedActivationObject],
    };
  };

  const updateZoneList = addedActivationObject => {
    dispatch(editLocalZone(returnProperActivationList(addedActivationObject)));
  };

  const editActivationRequest = async newActivation => {
    const objectToSend = {
      ...newActivation,
      zone: zoneDetails.uid,
    };
    const result = await authPostRequest('activations', objectToSend);
    if (result.status === 200) {
      dispatch(
        addAlert({
          title: language.alerts.addDataSuccess.title_,
          desc: `${language.alerts.addDataSuccess.desc_} ${
            language.zonesDetails.editForm.setType_
          } ${language.zonesDetails.infoDetails[
            `${newActivation.type}_`
          ]?.toLowerCase()}`,
          type: 'success',
        })
      );
      updateZoneList(result.data[0]);
    } else
      dispatch(
        addAlert({
          title: language.alerts[result.data.code].title_,
          desc: language.alerts[result.data.code].desc_,
          type: 'error',
        })
      );
  };

  const addActivation = () => {
    const newActivationObject = {
      start: start ? new Date(start).getTime() : null,
      stop: stop ? new Date(stop).getTime() : null,
      days: days.length ? days : null,
      hours: pickedHours.length ? pickedHours : null,
      type: activationType,
    };
    if (activationType === 'temporary') {
      const invalidRecordsArray = checkDataRanges(
        zoneDetails.activations,
        newActivationObject
      );
      if (invalidRecordsArray.length) {
        dispatch(
          addAlert({
            title: language.zonesDetails.addForm.activationForm.errorTitle_,
            desc: language.zonesDetails.addForm.activationForm.errorSubtitle_,
            type: 'error',
          })
        );

        return;
      }
    }
    editActivationRequest(newActivationObject);
    handleBackButton();
  };

  const handleBackButton = () => {
    setAddActivationFlag(false);
    setStop(null);
    setStart(null);
  };

  return (
    <Grid
      component="form"
      container
      spacing={2}
      className={`${formClasses.Form}__overflow-component ${formClasses.Form}--padding-left-right`}
      style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}
    >
      <Container>
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
        >
          {language.zonesDetails.addForm.activationForm.chooseActivationType_}
        </Typography>
      </Container>
      <Container>
        <FormControl
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex-between ${formClasses.Form}--width`}
          component="fieldset"
        >
          <RadioGroup
            aria-label="activation"
            name="activation"
            value={activationType}
            color="primary"
            onChange={handleChangeType}
          >
            <Grid container>
              <Grid
                className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
                item
                xs={4}
              >
                <FormControlLabel
                  value="periodic"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={
                    language.zonesDetails.addForm.activationForm
                      .radioPeriodicLabel_
                  }
                />
              </Grid>
              <Grid
                className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
                item
                xs={4}
              >
                <FormControlLabel
                  value="temporary"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={
                    language.zonesDetails.addForm.activationForm
                      .radioTemporaryLabel_
                  }
                />
              </Grid>
              <Grid
                className={`${formClasses.Form}__text-field ${formClasses.Form}--flex ${formClasses.Form}--flex--center ${formClasses.Form}--width`}
                item
                xs={4}
              >
                <FormControlLabel
                  value="permanent"
                  control={<Radio className={`${formClasses.Form}__switch`} />}
                  label={
                    language.zonesDetails.addForm.activationForm
                      .radioPermanentLabel_
                  }
                />
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </Container>
      <Container
        className={`${formClasses.Form}__overflow-component ${formClasses.Form}__overflow-component--small ${formClasses.Form}--padding-left-right`}
      >
        {activationType === 'periodic' && (
          <AddPeriodicForm
            weekdays={weekdays}
            toggleWeekdays={toggleWeekdays}
            days={days}
            hours={hours}
            toggleHours={toggleHours}
            pickedHours={pickedHours}
          />
        )}
        {activationType === 'temporary' && (
          <>
            <Typography
              variant="h3"
              className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
            >
              {language.zonesDetails.addForm.activationForm.temporaryInfo_}
            </Typography>

            <>
              {/* render if variable stop is set, because permanent rules have start values */}
              {!!zoneDetails.activations[0]?.stop && (
                <DisplayActivations
                  activations={zoneDetails.activations}
                  remove={deleteActivationRequest}
                />
              )}
            </>

            <AddTemporaryActivationModal
              setStart={setStart}
              setStop={setStop}
              start={start}
              stop={stop}
              addActivation={addActivation}
              handleBackButton={handleBackButton}
            />
          </>
        )}
        {activationType === 'permanent' && (
          <Typography
            variant="h3"
            className={`${formClasses.Form}__text-field__title ${formClasses.Form}__text-field`}
          >
            {language.zonesDetails.addForm.activationForm.permanentInfo_}
          </Typography>
        )}
      </Container>
      <Container>
        <div
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--flex-end ${formClasses.Form}--width`}
        >
          {activationType !== 'temporary' && (
            <>
              {zoneDetails.activations[0]?.type === activationType && (
                <Button
                  onClick={
                    () =>
                      deleteActivationRequest(
                        zoneDetails.activations[0],
                        activationType
                      )
                    // eslint-disable-next-line react/jsx-curly-newline
                  }
                  className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle}--reject ${classesButtons.ButtonsRectangle}`}
                  startIcon={<Icons.Actions.Close />}
                >
                  {language.zonesDetails.editForm.tableDel_}
                </Button>
              )}
            </>
          )}
          {activationType && activationType !== 'temporary' && (
            <Button
              onClick={() => addActivation(activationType)}
              className={`${classesButtons.Buttons} ${classesButtons.Buttons}--color ${classesButtons.ButtonsRectangle} `}
              startIcon={<Icons.Actions.Save2 />}
            >
              {language.zonesDetails.addForm.activationForm.saveButton_}
            </Button>
          )}
        </div>
      </Container>
    </Grid>
  );
};

EditActivationForm.propTypes = {
  language: PropTypes.object.isRequired,
  zoneDetails: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
  allLocalZones: state.allLocalZones,
});

export default connect(mapStateToProps)(EditActivationForm);
